<template>

    <div>
        <section class="section section-shaped my-0 overflow-hidden">
            <div class="shape shape-style-3 bg-gradient-default">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
            <div class="container pt-lg ">

                <div class="row text-center justify-content-center">
                    <div class="col-lg-10">
                        <h2 class="display-3 text-white">Demolition Delayed</h2>
                    </div>
                </div>
            </div>
        </section>
        <section class="section">
            <div class="container">
                <div class="row justify-content-center mt--100">
                    <div class="col-lg-12">
                        <card gradient="white" shadow body-classes="p-lg-5">
                            <h4 class="mb-1">{{post.text1}}</h4>
                            <div class="text-center mb-5 mt-5">
                                <img v-lazy="'img/brand/blog/demolition-delayed/cat-tastrophy5.png'" class="img-fluid rounded shadow"
                                     style="width: 350px;">
                            </div>
                            <p class="mt-4">{{post.text2}} <a href="https://www.offthecouchgames.com/covid">here</a>.</p>
                            <p>{{post.text3}}</p>
                            <p>{{post.text4}}</p>
                            <p>{{post.text5}}</p>
                            <p>Nick</p>


                            <div class="row mt-3 ml-1">
                                <small>Tags:
                                    <badge pill type="primary">announcement</badge>
                                </small>
                            </div>
                            <hr>
                            <div class="row">
                                <div class="ml-3">
                                    <img v-lazy="'img/brand/people/nick.jpg'" alt="Circle image"
                                         class="img-fluid rounded-circle shadow" style="width: 70px;">
                                </div>
                                <div class="ml-2">
                                    <h6 class="font-weight-800">{{post.author}}</h6>
                                    <p>Founder of OTC and Escape Room fanatic</p>

                                </div>
                            </div>


                        </card>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    export default {
        name: "DemolitionDelayed",
        data () {
            return {
                post: {
                    text1: "Off The Couch Remaining Open Until April 11th, 2021",
                    text2: "I want to thank everyone for your continued support, goodwill, and positivity during these difficult times. We have some slightly good news, the destruction of our building has been delayed and we have been granted a bit more time to showcase our games. We will be keeping our games open until April 11th, 2021 for anyone who hasn't had a chance to play them. All COVID-19 precautions are still enforced and can be seen",
                    text3: "We are hoping that there is a possibility of further delay, but it seems unlikely. We will keep everyone posted as we get more information. If you have any questions or concerns, please do not hesitate to reach out.",
                    text4: "Thank you again for helping keep our dreams alive.",
                    text5: "Best Regards,",
                    author: "Nick",
                    category: "announcements"
                }
            }
        },
        methods: {
            tracker(category, action, label) {
                this.$ga.event(category, action, label)
            }
        }
    }
</script>

<style scoped>

</style>
